(() => {
  if (window.vivantCatalogueBound) return;
  window.vivantCatalogueBound = true;
  let zoomTrigger;
  function prepareZoom() {
    document.querySelectorAll('.vs-product-zoom').forEach(dialog => {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = 'true';
      dialog.addEventListener('close', () => zoomTrigger?.focus({preventScroll:true}));
      dialog.addEventListener('click', e => {
        if (e.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) dialog.close();
      });
    });
  }
  document.addEventListener('click', e => {
    const filter = e.target.closest('[data-catalog-filter]');
    if (filter) {
      const catalogue = filter.closest('.vs-catalogue');
      let count = 0;
      catalogue.querySelectorAll('[data-catalog-card]').forEach(card => {
        const visible = filter.dataset.catalogFilter === 'all' || filter.dataset.catalogFilter === card.dataset.kind;
        card.hidden = !visible;
        card.closest('.vs-catalog-block').hidden = !visible;
        if (visible) count++;
      });
      catalogue.querySelectorAll('[data-catalog-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
      catalogue.querySelector('[data-catalog-count]').textContent = `${count} produit${count === 1 ? '' : 's'} à découvrir`;
    }
    const trigger = e.target.closest('[data-product-zoom]');
    if (trigger) {
      const dialog = document.querySelector('.vs-product-zoom');
      if (!dialog?.showModal) return;
      zoomTrigger = trigger;
      const image = trigger.querySelector('img').cloneNode(true);
      dialog.querySelector('[data-zoom-content]').replaceChildren(image);
      dialog.showModal();
    }
    if (e.target.closest('[data-close-zoom]')) e.target.closest('dialog').close();
  });
  document.addEventListener('shopify:section:load', prepareZoom);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareZoom); else prepareZoom();
})();
